import { apiJson, apiUrl } from "./apiClient";

export default function getGlossary() {
  return apiJson(apiUrl("/glossary"));
}

// The endpoint has been refactored to make it more perfomant.
// It is now not required to provide the 'glossary' parameter.
// Additionally, the 'text' parameter can be a single string or a list of strings.
// We have maintained both patterns to ensrue backward compatibility.
export function getGlossaryTooltips(text, glossary) {
  return apiJson(apiUrl("/glossary/tooltips"), {
    option: "POST",
    body: { text, glossary },
  });
}
